/* eslint-disable default-case */
/* eslint-disable import/no-anonymous-default-export */
import{
    GET_BOOKMARK_ARTICLES,
    GET_BOOKMARK_ARTICLES_SUCCESS,
    GET_BOOKMARK_ARTICLES_FAIL,
    GET_BOOKMARK_ARTICLES_RESET
} from '../action/getBookmarkArticlesAction'

import{ api_err_msg} from '../strings.json'

// initialState
const initialState = {
    apiState: "",
    list: [],
    message: ""
}
export default function(state = initialState, action){
    // console.log('action.type',action.type);
    switch(action.type){
        case GET_BOOKMARK_ARTICLES :
            return{ 
                ...state,
                apiState: 'loading'
            }
        case GET_BOOKMARK_ARTICLES_FAIL :  
            return{ 
                ...state,
                apiState: 'error',
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_BOOKMARK_ARTICLES_SUCCESS :  
            console.log('action.response.data',action.response.data);
            return{ 
                ...state,
                apiState: 'success',
                list: action.response.data.data.result,
            }

        case GET_BOOKMARK_ARTICLES_RESET:
            return initialState
        default:
            return {...state}
    }
}